import React from "react";
// import "./TeamSection.css";

const teamMembers = [
  {
    name: "CA Sunil Dad",
    role: "Partner",
    img: "/assets/img/CAsunil1.JPG",
  },
  {
    name: "CA Praveen Toshniwal",
    role: "Partner",
    img: "/assets/img/CApraveen1.JPG",
  },
  {
    name: "CA Malay Pandit",
    role: "Partner",
    img: "/assets/img/CAmalay.jpeg",
  },
  {
    name: "CA Shobha Rohit Bisht",
    role: "Partner (Mumbai)",
    img: "/assets/img/CAshobha2.jpeg",
  },
    {
    name: "CA Ankita Rathi",
    role: "Partner (Bhilwara )",
    img: "/assets/img/ANKITA PIC2.png",
  },
];

export default function TeamSection() {
  return (
    <section className="team-section">
      <div className="container">
        <h2 className="section-title">Meet Our Expert Team</h2>
        <p className="section-subtitle">
          A team of qualified Chartered Accountants and finance professionals committed to your business success.
        </p>
        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <div key={index} className="team-card">
              <div className="team-img-wrap">
                <img src={member.img} alt={member.name} className="team-img" />
              </div>
              <h5>{member.name}</h5>
              <span>{member.role}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}




// import React from "react";
// // import "./TeamSection.css";

// const team = [
//   {
//     name: "CA Sunil Dad",
//     role: "Partner",
//     img: "/assets/img/user.png",
//   },
//   {
//    name: "CA Praveen Toshniwal",
//     role: "Partner",
//     img: "/assets/img/user.png",
//   },
//    {
//     name: "CA Malay Pandit",
//     role: "Partner",
//     img: "/assets/img/CAmalay.jpeg",
//   },
//   {
//     name: "CA Shobha Rohit Bisht",
//     role: "Partner (Mumbai)",
//     img: "/assets/img/CAshobha.jpeg",
//   },
//     {
//     name: "CA Ankita Rathi",
//     role: "Partner (Bhilwara )",
//     img: "/assets/img/CAankita.jpeg",
//   },
// ];

// export default function TeamSection() {
//   return (
//     <section className="team-section">
//       <div className="container">
//         <p className="tag">OUR EXPERT</p>

//         <div className="header-row">
//           <h2 className="title">Meet the expert accounting people</h2>

//           <p className="subtext">
//             Free yourself from the burden of daily financial records. We provide
//             expert support and meticulous management you need to ensure your
//             books are always accurate.
//           </p>
//         </div>

//         <div className="team-grid">
//           {team.map((member, index) => (
//             <div key={index} className="team-card">
//               <div className="image-wrapper">
//                 <img src={member.img} alt={member.name} />
//                 {/* <button className="share-btn">
//                   <i className="fa fa-share-alt"></i>
//                 </button> */}
//               </div>

//               <div className="info-box">
//                 <h4>{member.name}</h4>
//                 <p>{member.role}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }
